export default __webpack_public_path__ + "static/media/C7SD80_C7SJ80_C7SJ81_C7SK80_C7SK81_C7RW80.1cce7ff8.png";